<template>
  <ym-loadmore v-if="list && list.length > 0"
               ref="reviews"
               class="review-list"
               :class="{ 'pb': !showBottomBar }"
               v-model="loading"
               :finished="allLoad"
               finished-text="没有更多了"
  >
    <item-new v-for="(item, index) in list"
              :key="index"
              :item="item"
    />
  </ym-loadmore>
  <div v-else
       class="empty"
  >
    暂无评价
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import ItemNew from '@/pages/Review/components/ReviewItemNew';
  import { getCourseComment } from '@/services/course';
  import { LIMIT } from '@/utils/constant';
  import { throttle } from '@/utils';

  export default {
    name: 'ReviewList',
    components: {
      'ym-loadmore': Loadmore,
      ItemNew,
    },
    props: {
      reviews: {
        type: Array,
      },
      nextStart: {
        type: Number,
        default: 0,
      },
      targetId: {
        type: Number,
      },
      targetType: {
        type: String,
      },
      showBottomBar: Boolean,
    },
    data() {
      return {
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
        listHeight: 0,
      };
    },
    watch: {
      reviews: {
        handler(val) {
          this.list = val;
        },
        immediate: true,
      },
      nextStart: {
        handler(val) {
          this.start = val;
        },
        immediate: true,
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad || this.loading) return;

        this.loading = true;
        let data = {};
        data = await getCourseComment({
          id: this.targetId,
          type: this.targetType,
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);

        if (data.list.length === 0) {
          this.stopData();
          return;
        }

        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;

        this.controlScrollHandler();
      },
      controlScrollHandler(init) {
        this.$nextTick(() => {
          const rect = this.$refs.reviews.$el.getBoundingClientRect();
          this.listHeight = rect.height;
          if (init && !this.allLoad) {
            window.addEventListener('scroll', this.onScrollHandler);
          }
        });
      },
      removeScrollHandler() {
        window.removeEventListener('scroll', this.onScrollHandler);
      },
      onScrollHandler: throttle(function () {
        const { scrollTop } = document.scrollingElement;
        if ((this.listHeight - scrollTop) < 300) this.fetchData();
      }, 50),
      resetData() {
        this.start = this.nextStart;
        this.allLoad = false;
        this.loading = false;
        this.controlScrollHandler(true);
      },
      stopData() {
        this.allLoad = true;
        this.loading = false;
        this.removeScrollHandler();
      },
    },
    created() {},
    beforeDestroy() {
      this.removeScrollHandler();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .review-list {
    &.pb {
      padding-bottom: 140px;
    }
  }

  /deep/ .review-item {
    padding-top: 60px;
    padding-bottom: 0;
  }
</style>
